module.exports = __webpack_public_path__ + "assets/img/e73617a106184b3bf7d1c62f4a6ca2b2.svg";